import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

export default class extends Controller {
  static values = {
    resetPath: String,
  };

  resetFilters = () => {
    window.history.pushState({}, '', this.resetPathValue);
    this.visitUrl(new URL(this.resetPathValue, window.location.origin));
  };

  visitUrl = (url) => {
    get(url, { responseKind: 'turbo-stream' });
  };
}
